module.exports = __webpack_public_path__ + "img/ar.0436fb42.jpg";